import { render, staticRenderFns } from "./ContactTimelineEvent.vue?vue&type=template&id=dc6060dc&"
import script from "./ContactTimelineEvent.vue?vue&type=script&setup=true&lang=js&"
export * from "./ContactTimelineEvent.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports